export default __webpack_public_path__ + "static/python-advanced-6c8df43b0ee0e0b59560780cc97684c6.webp";